var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C6.70588 0 0 6.90078 0 15.3452C0 22.1551 4.32353 27.8755 10.2353 29.9639C11.0294 30.0547 11.2941 29.6007 11.2941 29.2375V26.3319C7.5 27.0583 6.52941 25.4239 6.26471 24.5159C6.08824 24.0619 5.38235 22.6999 4.76471 22.3367C4.23529 22.0643 3.52941 21.3379 4.76471 21.3379C5.91176 21.3379 6.79412 22.4275 7.05882 22.8815C8.38235 25.2423 10.5882 24.5159 11.4706 24.1527C11.5588 23.1539 12 22.5183 12.4412 22.0643C9.08824 21.7011 5.64706 20.3392 5.64706 14.4372C5.64706 12.8028 6.26471 11.35 7.14706 10.3512C6.97059 9.98798 6.44118 8.35358 7.32353 6.26519C7.32353 6.26519 8.55882 5.90199 11.4706 7.80878C12.7059 7.44558 13.9412 7.26398 15.1765 7.26398C16.4118 7.26398 17.7353 7.44558 18.8824 7.80878C21.6176 5.90199 22.9412 6.35598 22.9412 6.35598C23.7353 8.44438 23.2059 10.0788 23.1176 10.442C24.0882 11.5316 24.6176 12.8936 24.6176 14.528C24.6176 20.43 21.0882 21.7011 17.7353 22.1551C18.2647 22.6091 18.7059 23.5171 18.7059 24.9699V29.2375C18.7059 29.6007 18.9706 30.1455 19.7647 29.9639C25.6765 27.8755 30 22.1551 30 15.3452C30 6.90078 23.2941 0 15 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortGit);
export default __webpack_public_path__ + "static/media/port-git.5cc48168baf6fc4955da111332da54d2.svg";
export { ForwardRef as ReactComponent };